import React from "react";
import EnvironmentScience from "../../components/UKG/EnvironmentScience";
import EnvironmentScienceMenu from "./EnvironmentScience";
import English from "../../components/UKG/English";
import EnglishMenu from "./English";
import Mathematics from "../../components/UKG/Mathematics";
import MathematicsMenu from "./Mathematics";
import GeneralAwareness from "../../components/UKG/GeneralAwareness";
import GeneralAwarenessMenu from "./GeneralAwareness";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; 
    subMenu?: MenuItem[]; 
}

// Define ClassTwoMenu with the proper type
const UKGMenu: MenuItem[] = [
    { 
        url: "/ukg/english-language", 
        title: "English Language", 
        component: English,
        subMenu: EnglishMenu
    },
    { 
        url: "/ukg/mathematics", 
        title: "Mathematics", 
        component: Mathematics,
        subMenu: MathematicsMenu
    },
    { 
        url: "/ukg/environmental-science", 
        title: "Environmental Science (EVS)", 
        component: EnvironmentScience,
        subMenu: EnvironmentScienceMenu
    },
    { 
        url: "/ukg/general-awareness", 
        title: "General Awareness", 
        component: GeneralAwareness,
        subMenu: GeneralAwarenessMenu
    }
    // { 
    //     url: "/ukg/computer-studies", 
    //     title: "Computer Studies"
    // }
];

export default UKGMenu;

